import React from "react";

import i18n from "../i18n";

const positivePatterns = [/[0-9]/, /[a-z]/, /[A-Z]/, /[^\s\w]/];
const negativePatterns = [/(.{2})\1/];

const maxConsecutiveSequence = value => {
  let max = 0;
  let len = 1;

  for (let i = 1; i < value.length; ++i) {
    if (value.charCodeAt(i) !== value.charCodeAt(i - 1) + 1) {
      max = len > max ? len : max;
      len = 0;
    }
    len++;
  }

  max = len > max ? len : max;
  return max;
};

const hasConsecutiveParts = value => {
  // has more than 3 consecutive same-case letters or numbers
  const ms = value.match(/([a-z]{4,})|([A-Z]{4,})|([0-9]{4,})/g);

  for (const m of ms) {
    // console.log(m, maxConsecutiveSequence(m));
    if (maxConsecutiveSequence(m) > 3) return true;
  }

  return false;
};

const validatePassword = (_, value, callback) => {
  if (!value) {
    return callback(<div>{i18n.t("auth:signup.emptyPassword")}</div>);
  }
  if (value.length < 11) {
    return callback(<div>{i18n.t("auth:signup.minChars", { count: 11 })}</div>);
  }
  if (value.length > 128) {
    return callback(
      <div>{i18n.t("auth:signup.maxChars", { count: 128 })}</div>
    );
  }
  if (
    positivePatterns.every(p => p.test(value)) &&
    negativePatterns.every(p => !p.test(value)) &&
    !hasConsecutiveParts(value)
  ) {
    return callback();
  }
  return callback(<div>{i18n.t("auth:signup.invalidPassword")}</div>);
};

export const passwordValidateRules = [{ validator: validatePassword }];

const comparePasswords = (form, fieldName) => (_, value, callback) => {
  if (!value) {
    return callback(<div>{i18n.t("auth:signup.confirmPassword")}</div>);
  }
  if (value !== form.getFieldValue(fieldName)) {
    return callback(<div>{i18n.t("auth:signup.doesNotMatch")}</div>);
  }
  return callback();
};

export const passwordCompareRules = (form, fieldName) => [
  { validator: comparePasswords(form, fieldName) }
];
